module.exports = require("./../../_gen/openfl/display3D/VertexBuffer3D");